import { Instagram, Mail, Phone, MessageCircle, MapPin } from "lucide-react";

const CONTACTS = [
  {
    href: "mailto:indiorajourneys@gmail.com",
    icon: Mail,
    label: "indiorajourneys@gmail.com",
  },
  {
    href: "tel:+918287828387",
    icon: Phone,
    label: "+91 82878 28387",
    testId: "footer-phone",
  },
  {
    href: "https://wa.me/918287828387",
    icon: MessageCircle,
    label: "WhatsApp us",
    testId: "footer-whatsapp",
    external: true,
  },
  {
    href: "https://instagram.com/indiorajourneys",
    icon: Instagram,
    label: "@indiorajourneys",
    external: true,
  },
];

export default function FooterContacts() {
  return (
    <div className="md:col-span-4">
      <div className="text-[10px] tracking-widest3 uppercase text-ivory/50 mb-6">
        Correspond
      </div>
      {CONTACTS.map(({ href, icon: Icon, label, testId, external }) => (
        <a
          key={href}
          href={href}
          data-testid={testId}
          {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
          className="flex items-center gap-3 hover:text-goldleaf transition-colors mb-4 font-light last:mb-8"
        >
          <Icon size={16} strokeWidth={1.2} />
          {label}
        </a>
      ))}

      <div className="text-[10px] tracking-widest3 uppercase text-ivory/50 mb-3 mt-2">
        Atelier Address
      </div>
      <address
        data-testid="footer-address"
        className="not-italic flex items-center gap-3 text-ivory/75 font-light leading-relaxed"
      >
        <MapPin size={16} strokeWidth={1.2} className="shrink-0 text-goldleaf" />
        <span>C-28-A, Vishwakarma Colony, New Delhi — 110044, India</span>
      </address>
    </div>
  );
}
